export const SET_MENU_OPEN = 'SET_MENU_OPEN';

export const setMenuOpen = (open) => {
  return {
    type: SET_MENU_OPEN,
    open,
  };
};
